<template>
  <div>
    <div class="content-bg">
      <div class="content-border-wrapper note">
        <section class="cw-section note-quote" v-if="noteRefData">
          <div class="pic"><img :src="noteRefData.imageUrl | imageUrl('?imageView2/1/w/80/h/80')"></div>
          <div class="content">
            <span>{{noteRefData.text}}</span>
          </div>
        </section>
        <section class="cw-section note-info">
          <div class="publish" v-if="info.userDetailInfo && info.noteInfo">
            <div class="pic"><img :src="info.userDetailInfo.logoUrl | imageUrl('?imageView2/1/w/40/h/40')"></div>
            <div class="content">
              <span class="time">{{info.noteInfo.createTime | formatDateTime}}</span>
              <h2 class="name" :style="info.star ? '' : `line-height:40px;`">{{info.userDetailInfo.nickName}}</h2>
              <div class="star" v-if="info.star">
                <span class="is-left">给出评分</span>
                <p class="star-default">
                  <span class="star-active" :style="`width:${info.star*10}%`"></span>
                </p>
              </div>
            </div>
          </div>
          <div class="note-content" v-if="subject" v-html="subject"></div>
          <template v-if="info.notePhotos">
            <template v-for="item in info.notePhotos">
              <div class="note-video" :key="item.id" v-if="item.resourceType">
                <video :src="item.resourceUrl" :poster="item.imageUrl" preload="auto" controls></video>
              </div>
              <div class="note-pic" :key="item.id" v-else>
                <img :src="item.imageUrl | imageUrl('?imageView2/2/w/638')" />
              </div>
            </template>
          </template>
        </section>
        <section class="cw-section" v-if="comments.datas && comments.datas.length">
          <div class="hd cw-hd">
            <h2 class="title">评论
              <span>({{comments.count}}条)</span>
            </h2>
          </div>
          <div class="bd">
            <commentList :datas="comments.datas"></commentList>
          </div>
        </section>
        <section class="cw-section" v-if="videoNotes.length">
          <div class="hd cw-hd">
            <h2 class="title">相关笔记推荐</h2>
            <span class="more">
              <router-link to="/notes">更多</router-link>
            </span>
          </div>
          <div class="bd">
            <notesList type="video" :columns="3" :gutter="19" :data="videoNotes"></notesList>
          </div>
        </section>
      </div>
    </div>
    <appbar></appbar>
  </div>
</template>
<script>
import appbar from '../common/appbar'
import commentList from '../common/commentList'
import notesList from '../common/notesList'
import { getNoteDetail, getVideoNoteList } from '@/api/zaiart'
import { resolveContent } from '@/utils/filters'

export default {
  components: { appbar, commentList, notesList },
  data() {
    return {
      pageId: null,
      info: {},
      comments: {},
      noteRefData: null,
      videoNotes: []
    }
  },
  computed: {
    subject() {
      let result = ''
      if (this.info.noteContent && this.info.noteContent.content) {
        // resolveContent(value, maxWidth)
        result = resolveContent(this.info.noteContent.content, '638')
      }
      return result
    }
  },
  methods: {
    init() {
      this.getDetailData()
      this.getVideoNoteList()
    },
    getDetailData() {
      const param = { id: this.pageId }
      return getNoteDetail(param).then(response => {
        this.info = response.data.info
        this.comments = response.data.comments
        this.noteRefData =
          (response.data.info && response.data.info.noteRefData) ||
          null
      })
    },
    getVideoNoteList() {
      const param = { id: this.pageId }
      return getVideoNoteList(param).then(response => {
        this.videoNotes = response.data.list
      })
    }
  },
  created() {
    this.pageId = this.$route.params.id
    this.init()
  }
}
</script>
<style>
.note .note-quote {
  height: 100px;
  padding: 10px 20px;
  background-color: #e5eef8;
  border: 1px solid #f0f0f0;
}
.note .note-quote .pic {
  float: left;
  width: 80px;
  height: 80px;
}
.note .note-quote .content {
  position: relative;
  height: 80px;
  margin-left: 94px;
}
.note .note-quote .content::before {
  content: '';
  line-height: 80px;
  vertical-align: middle;
}
.note .note-quote .content p {
  font-size: 16px;
  color: #3c3c3c;
  line-height: 22px;
}

.note .note-info .publish {
  height: 40px;
  margin-bottom: 20px;
}
.note .note-info .publish .pic {
  float: left;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid #dadada;
}
.note .note-info .publish .content {
  margin-left: 52px;
}
.note .note-info .publish .time {
  float: right;
  font-size: 12px;
  line-height: 40px;
  color: #999;
}
.note .note-info .publish .name {
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  color: #3c3c3c;
}
.note .note-info .publish .star {
  font-size: 12px;
  color: #999;
  line-height: 20px;
}
.note .note-info .publish .star .star-default {
  float: left;
  margin-top: 5px;
  margin-left: 6px;
  line-height: 0;
  width: 55px;
  height: 11px;
  background: url('../../../assets/img/icon/icon_star_default.png') repeat-x;
  background-size: 11px 11px;
}
.note .note-info .publish .star .star-active {
  display: inline-block;
  max-width: 55px;
  height: 11px;
  background: url('../../../assets/img/icon/icon_star.png') repeat-x;
  background-size: 11px 11px;
}
.note .note-content {
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 20px;
}
.note .note-pic {
  margin-bottom: 20px;
  text-align: center;
}
.note .note-pic img {
  max-width: 100%;
}
.note .note-video {
  height: 360px;
  background-color: #000;
}
.note .note-video video {
  width: 100%;
  height: 100%;
}
video::-internal-media-controls-download-button {
  display: none;
}
video::-webkit-media-controls-enclosure {
  overflow: hidden;
}
video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
</style>
